import React, { useState, useEffect, useCallback } from "react";
import { db } from "../firebaseConfig";
import {
  collection,
  addDoc,
  getDocs,
  //where,
  //query,
} from "firebase/firestore";
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Typography, Checkbox,
  TextField, Paper, Grid, Button
} from '@mui/material';
import jsPDF from "jspdf";

const inspectionItems = [
"Lavado",
"Llantas",
];

const lucesInspectionItems = [
 "Luces - revisar",
 "Refacciones - revisar todas",
 "Wiring & light sockets check"
];

const rearBrakeLiningInspectionItems = [
"Gavilanes porta gavilan - quitar tapa de tierra",
"Condiciones del tambor",
"Frenos - ajuste"
];

const ruedasItems = [
  "Tapas de las masas -  cambiar si es necesario",
  "Nivel de Aceite",
];

const runningGearItems = [
"Revisión de fugas de aire en rota chambers",
"valvulas y lineas de aire",
"mangeras de aire - averías",
];

// const fugasItems = [
//   "Anticongelante",
//   "Aceite de motor",
//   "Aceite de dirección",
//   "Aceite de transmisión",
//   "Aceite de diferencial delantero",
//   "Aceite de diferencial trasero",
//   "Aceite de las masas de cada rueda",
//   "Fugas de aire",
// ];

// const miscelaneosItems = [
//   "Valvulas de escape rapido - revision de valvulas de emergencia",
//   "vaciar tanques de aire",
//   "muelles y abrazaderas - revisar",
//   "Cargadores - revisar",
//   "Mecanismos de los tandems",
//   "Zoqueteras - revisar",
//   "Placas y permisos -  permitidos",
// ];

const carroceriasItems = [
"Revisar las hojas paneles - record",
"Puertas, bisagras, herrajes",
"Puerta en general - abrir, cerrar, filtraciones",
"pisos - revisión de pisos",
"filtraciones de hoyo en techo",
"filtracion de luz en puertas",
];

const patinesyperno = [
  "Soporte de los patines",
  "Manibela check",
  "caja de engranes, rellenar si es necesario",
  "Perno Rey y plato de la quinta - revisar",
];



export default function TruckInspectionForm() {
  const [folio, setFolio] = useState("");
  //const [loading, setLoading] = useState(false);

  const [formStateGeneral, setFormStateGeneral] = useState(
    inspectionItems.map(() => ({ ok: false, ajuste: false, adicional: false, comentario: '' }))
  );
  const [formStateLuces, setFormStateLuces] = useState(
    lucesInspectionItems.map(() => ({ ok: false, ajuste: false, adicional: false, comentario: '' }))
  );
  const [formStateEjeDelantero, setFormStateEjeDelantero] = useState(
    rearBrakeLiningInspectionItems.map(() => ({ ok: false, ajuste: false, adicional: false, comentario: '' }))
  );
  const [formStateFrenos, setFormStateFrenos] = useState(
    ruedasItems.map(() => ({ ok: false, ajuste: false, adicional: false, comentario: '' }))
  );
  const [formStateFluidos, setFormStateFluidos] = useState(
    runningGearItems.map(() => ({ ok: false, ajuste: false, adicional: false, comentario: '' }))
  );
  // const [formStateFugas, setFormStateFugas] = useState(
  //   fugasItems.map(() => ({ ok: false, ajuste: false, adicional: false, comentario: '' }))
  // );
  // const [formStateMiscelaneos, setFormStateMiscelaneos] = useState(
  //   miscelaneosItems.map(() => ({ ok: false, ajuste: false, adicional: false, comentario: '' }))
  // );
  const [formStateSeguridad, setFormStateSeguridad] = useState(
    carroceriasItems.map(() => ({ ok: false, ajuste: false, adicional: false, comentario: '' }))
  );
  const [formStatepatinesyperno, setFormStatepatinesyperno] = useState(
    patinesyperno.map(() => ({ ok: false, ajuste: false, adicional: false, comentario: '' }))
  );


  // const getNextFolio = async () => {
  //   const snapshot = await getDocs(collection(db, "inspecciones"));
  //   const folios = snapshot.docs
  //     .map(doc => doc.data().folio)
  //     .filter(folio => folio?.startsWith("ITS"))
  //     .map(folio => parseInt(folio.replace("ITS", "")))
  //     .filter(num => !isNaN(num));

  //   const maxFolio = folios.length > 0 ? Math.max(...folios) : 0;
  //   return `IRS${String(maxFolio + 1).padStart(4, '0')}`; // ejemplo: ITS0001
  // };


  const generateFolio = async () => {
    const snapshot = await getDocs(collection(db, "inspecciones"));
    const count = snapshot.size + 1;
    return `IRS-${count.toString().padStart(6, "0")}`;
  };
  
  const generarPDF = (folio, data) => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text(`Folio: ${folio}`, 10, 10);
    doc.text(`Fecha: ${new Date().toLocaleString()}`, 10, 20);

    const agregarSeccion = (titulo, items, estado, yStart) => {
      doc.setFontSize(12);
      doc.text(titulo, 10, yStart);
      let y = yStart + 5;
      items.forEach((item, i) => {
        const val = estado[i];
        const detalles = `OK: ${val.ok ? "✓" : "X"}, Ajuste: ${val.ajuste ? "✓" : "X"}, Adicional: ${val.adicional ? "✓" : "X"}`;
        const comentario = val.comentario ? ` Comentario: ${val.comentario}` : "";
        doc.text(`- ${item}: ${detalles}${comentario}`, 10, y);
        y += 6;
        if (y > 280) {
          doc.addPage();
          y = 10;
        }
      });
      return y;
    };

    let y = 30;
    y = agregarSeccion("Inspección General", inspectionItems, data.general, y);
    y = agregarSeccion("Luces", lucesInspectionItems, data.luces, y);
    y = agregarSeccion("Eje Delantero", rearBrakeLiningInspectionItems, data.ejeDelantero, y);
    y = agregarSeccion("Frenos", ruedasItems, data.frenos, y);
    y = agregarSeccion("Fluidos", runningGearItems, data.fluidos, y);
   // y = agregarSeccion("Fugas", fugasItems, data.fugas, y);
    //y = agregarSeccion("Misceláneos", miscelaneosItems, data.miscelaneos, y);
    y = agregarSeccion("Equipo de Seguridad", carroceriasItems, data.seguridad, y);
    y = agregarSeccion("Sistema DEF", patinesyperno, data.patinesyperno, y);

    doc.save(`${folio}.pdf`);
  };


  const handleCheckboxChange = (index, field, section) => {
    const states = {
      general: [formStateGeneral, setFormStateGeneral],
      luces: [formStateLuces, setFormStateLuces],
      ejeDelantero: [formStateEjeDelantero, setFormStateEjeDelantero],
      frenos: [formStateFrenos, setFormStateFrenos],
      fluidos: [formStateFluidos, setFormStateFluidos],
     // fugas: [formStateFugas, setFormStateFugas],
     // miscelaneos: [formStateMiscelaneos, setFormStateMiscelaneos],
      seguridad: [formStateSeguridad, setFormStateSeguridad],
      patinesyperno: [formStatepatinesyperno, setFormStatepatinesyperno],
    };

    const [state, updater] = states[section];
    const newState = [...state];
    newState[index][field] = !newState[index][field];
    updater(newState);
  };

  const handleCommentChange = (index, value, section) => {
    const states = {
      general: [formStateGeneral, setFormStateGeneral],
      luces: [formStateLuces, setFormStateLuces],
      ejeDelantero: [formStateEjeDelantero, setFormStateEjeDelantero]
    };

    const [state, updater] = states[section];
    const newState = [...state];
    newState[index].comentario = value;
    updater(newState);
  };
  const handleGuardar = async () => {
    const folioGenerado = await generateFolio();

    const data = {
      folio: folioGenerado,
      fecha: new Date().toISOString(),
      general: formStateGeneral,
      luces: formStateLuces,
      ejeDelantero: formStateEjeDelantero,
      frenos: formStateFrenos,
      fluidos: formStateFluidos,
     // fugas: formStateFugas,
    //  miscelaneos: formStateMiscelaneos,
      seguridad: formStateSeguridad,
      patinesyperno: formStatepatinesyperno,
    };

    try {
      await addDoc(collection(db, "inspecciones"), data);
      setFolio(folioGenerado);
      generarPDF(folioGenerado, data);
      alert("Inspección guardada correctamente.");
    } catch (error) {
      console.error("Error al guardar la inspección:", error);
      alert("Ocurrió un error al guardar la inspección.");
    }
  };

  const renderSection = (title, items, state, sectionKey) => (
    <div>
      <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
        {title}
      </Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell align="center">OK</TableCell>
              <TableCell align="center">Requiere Ajuste</TableCell>
              <TableCell align="center">Requiere Trabajo Adicional</TableCell>
              <TableCell>Comentario</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{item}</TableCell>
                <TableCell align="center">
                  <Checkbox
                    checked={state[index].ok}
                    onChange={() => handleCheckboxChange(index, 'ok', sectionKey)}
                  />
                </TableCell>
                <TableCell align="center">
                  <Checkbox
                    checked={state[index].ajuste}
                    onChange={() => handleCheckboxChange(index, 'ajuste', sectionKey)}
                  />
                </TableCell>
                <TableCell align="center">
                  <Checkbox
                    checked={state[index].adicional}
                    onChange={() => handleCheckboxChange(index, 'adicional', sectionKey)}
                  />
                </TableCell>
                <TableCell>
                  {state[index].adicional && (
                    <TextField
                      fullWidth
                      size="large"
                      placeholder="Describa el trabajo adicional"
                      value={state[index].comentario}
                      onChange={(e) => handleCommentChange(index, e.target.value, sectionKey)}
                    />
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );

  return (
    <Paper sx={{ p: 4, maxWidth: '1200px', mx: 'auto' }}>
      <Typography variant="h5" gutterBottom>
        Inspección del Remolques
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          {renderSection("Mantenimiento Remolque", inspectionItems, formStateGeneral, 'general')}
        </Grid>
        <Grid item xs={12} md={6}>
          {renderSection("Luces y Cableados", lucesInspectionItems, formStateLuces, 'luces')}
        </Grid>
        <Grid item xs={12} md={6}>
          {renderSection("Rear Brake Lining Inspection", rearBrakeLiningInspectionItems, formStateEjeDelantero, 'ejeDelantero')}
        </Grid>
        <Grid item xs={12} md={6}>
          {renderSection("Ruedas", ruedasItems, formStateFrenos, 'frenos')}
        </Grid>
        <Grid item xs={12} md={6}>
          {renderSection("Running Gear", runningGearItems, formStateFluidos, 'fluidos')}
        </Grid>
        {/* <Grid item xs={12} md={6}>
          {renderSection("Fugas", fugasItems, formStateFugas, 'fugas')}
        </Grid>
        <Grid item xs={12} md={6}>
          {renderSection("Misceláneos", miscelaneosItems, formStateMiscelaneos, 'miscelaneos')}
        </Grid> */}
        <Grid item xs={12} md={6}>
          {renderSection("Carrocerias", carroceriasItems, formStateSeguridad, 'seguridad')}
        </Grid>
        <Grid item xs={12} md={6}>
          {renderSection("Patines y Perno Rey", patinesyperno, formStatepatinesyperno, 'patinesyperno')}
        </Grid>
      </Grid>

      <Grid item xs={12}>
        {folio && (
          <Typography variant="h6" sx={{ mt: 4 }}>
            Folio generado: <strong>{folio}</strong>
          </Typography>
        )}

        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 4 }}
          onClick={handleGuardar}
        >
          Guardar inspección
        </Button>
      </Grid>

    </Paper>
  );
}

